// Loan calculator 
var loanCalcIntervalTries = 25;
var loanCalcInterval = setInterval(function() {
    if ($('body').is('.main-home.with-loan-calculator')) {
        setupLoanCalc();
        clearInterval(loanCalcInterval);
    }
    if (loanCalcIntervalTries <= 0) {
        clearInterval(loanCalcInterval);
    }
    loanCalcIntervalTries--;
}, 500);

function setupLoanCalc() {
    var loanCalculatorMonthlySlider = $('#loan_calculator_slider_monthly-label-container');
    var loanCalculatorAffordSlider = $('#loan_calculator_slider_afford-label-container');
    var loanTermSelect = $('[name=loan-calc-term-select]');
    var loanAprSelect = $('[name=loan-calc-apr-select]');
    var loanAprInput = $('[name=loan-calc-apr-input]');
    var termFieldGroup =  $('.term-field-form-group');      
    var aprFieldGroup =  $('.apr-field-form-group');   
    var termFieldGroupLabel =  $('.term-field-form-group label');   
    var aprFieldGroupLabel =  $('.apr-field-form-group label');   
    var summaryTextMonthlyContainer = $('#summary-text-monthly-repayment-container');
    var summaryTextAffordContainer = $('#summary-text-afford-container');
    var summaryTextBtnContainer = $('#summary-text-btn-container');
    var calculateMyRepaymentsBtnContainer= $('#calculate-my-repayments-btn-container');
    var loanCalcRadioButtonMonthly = $('#loan-calc-radio-button-monthly');
    var loanCalcRadioButtonAfford = $('#loan-calc-radio-button-afford');
    var stopLoanCalcSpinner = false;
    $('.numeric-only').numeric();
    loanTermSelect.val(0);
    loanAprSelect.val(0);
    loanAprInput.val('');
    
    // Init sliders after 500ms
    setTimeout(function() {
        $('#loan_calculator_monthly_range_slider').rangeslider({
            polyfill: false,
            onInit: function() {
                $('#loan_calculator_val_monthly').text('£' + withCommas(window.la.val()));
            },
            onSlide: function(pos, value) {
                // Format val and set the display
                $('#loan_calculator_val_monthly').text('£' + withCommas(value));
                calculateRepayments();
            }
        });
    }, 500);
    setTimeout(function() {
        $('#loan_calculator_afford_range_slider').rangeslider({
            polyfill: false,
            onSlide: function(pos, value) {
                // Format val and set the display
                $('#loan_calculator_val_afford').text('£' + withCommas(value));
                calculateRepayments();
            }
        });
    }, 500);
    
    // Click handler for the loan calculator radio button
    $(document).on('click', '.loan-calc-radio-button', function(event) {
        $('.loan-calc-radio-button').removeClass('active');
        $(this).addClass('active');
        calculateRepayments();
    });
    
    // Click handler for the monthly button
    $(document).on('click', '#loan-calc-radio-button-monthly', function(event) {
        loanCalculatorMonthlySlider.removeClass('hidden');
        loanCalculatorAffordSlider.addClass('hidden');
        showSummaryTextMonthlyContainer();
    });
    
    // Click handler for the budget button
    $(document).on('click', '#loan-calc-radio-button-afford', function(event) {
        loanCalculatorMonthlySlider.addClass('hidden');
        loanCalculatorAffordSlider.removeClass('hidden');
        showSummaryTextAffordContainer();
    });
    
    // Validation
    $(document).on('change', '[name=loan-calc-term-select]', function(event){
        if (loanTermSelect.val() != null) {
            markTermFieldValid();
        }
    });
    // Change handler for the APR input - When the user is specifiying a custom interest rate
    $(document).on('change', '[name=loan-calc-apr-input]', function(event){ 
        var loanAprInput = $(event.target);
        if (loanAprInput.val() != '') {
            markAprFieldValid();
        }
        if (loanAprInput.val() == '') {
            loanAprInput.val('');
            resetAprField();
        } else if (parseFloat(loanAprInput.val().replace(/[^0-9\.]/g, '')) < 11.8) {
            loanAprInput.val('11.8%');
        } else if (parseFloat(loanAprInput.val().replace(/[^0-9\.]/g, '')) > 1625.5) {
            loanAprInput.val('1625.5%');
        } else {
            loanAprInput.val(function(index, old) { return old.replace(/[^0-9\.]/g, '') + '%'; });
        }
    });
    
    // Change APR Select
    $(document).on('change', '[name=loan-calc-apr-select]', function(event){
        var loanAprSelect = $(event.target);
        if (loanAprSelect.val() != null) {
            markAprFieldValid();
        } 
        if (loanAprSelect.val() == 'Other') {
            stopLoanCalcSpinner = true;
            showLoanAprInput();
        }
    });
    
    // Change handler for loan term, apr selet or apr input
    $(document).on('change', '[name=loan-calc-term-select], [name=loan-calc-apr-select], [name=loan-calc-apr-input]', function(event) {
        if (calculateMyRepaymentsBtnContainer.hasClass('hidden')) {
            showLoanCalcSpinner();
        } 
        calculateRepayments();
    });
    
    // Calculator form button click
    $(document).on('click', '#calculate-my-repayments-btn', function(event) {
        validateLoanCalcFields();
    });
    
    function getMonthlyPayment(amount, term , apr) {
        amount = parseFloat(amount.toString().replace(/[,£]/g, ''));
        term = parseFloat(term);
        apr = parseFloat(apr) / 100;
        var rate = parseFloat(apr/12);
        return (rate * amount / ( 1 - Math.pow((1 + rate), -1 * term)));
    }
    
    function getMaxLoanForMonthlyBudget(budget, term, apr) {
        budget = parseFloat(budget.toString().replace(/[,£]/g, ''));
        term = parseFloat(term);
        apr = parseFloat(apr) / 100;
        var rate = apr / 12;
        return (budget * (1 - Math.pow((1 + rate), -1 * term))) / rate;
    }
    
    function validateLoanCalcFields() {
        if (loanTermSelect.val() == null) {
            errorTermField();
        }
        if (loanAprInput.hasClass('hidden')) {
            if (loanAprSelect.val() == null) {
                errorAprField();
            }
            if (loanTermSelect.val() != null && loanAprSelect.val() != null) {
                showLoanCalcSpinner();
            } 
        } else {
            if (loanAprInput.val() == '') {
                errorAprField();
            }
            if (loanTermSelect.val() != null && loanAprInput.val() != '') {
                showLoanCalcSpinner();
            }
        }
        return false;
    }
    
    function calculateRepayments() {
        if (!summaryTextBtnContainer.hasClass('hidden')) {
            var loanCalculatorMonthlySliderVal = $('#loan_calculator_val_monthly').text();
            var loanCalculatorAffordSliderVal = $('#loan_calculator_val_afford').text();
            if (loanAprInput.hasClass('hidden')) {
                var loanAprVal = loanAprSelect.val();
            } else {
                var loanAprVal = loanAprInput.val();
            }
            var loanTermVal = loanTermSelect.val();
            if (loanCalcRadioButtonMonthly.hasClass('active')) {
                var valueMonthlyText = $('#value-monthly-text');
                var monthlyFloatMonthly = getMonthlyPayment(loanCalculatorMonthlySliderVal, loanTermVal, loanAprVal);
                var finalValueMonthly = monthlyFloatMonthly.toFixed(2);
                // Set the values on the front end
                if (isNaN(finalValueMonthly)) {
                    valueMonthlyText.text('N/A');
                } else {
                    // Go and set the window la value
                    var valueToSetMonthly = parseFloat($('#loan_calculator_val_monthly').text().replace(/[^0-9\.]/g, ''));
                    window.la.val(valueToSetMonthly).change();
                    // Final text 
                    valueMonthlyText.text('£'+withCommas(finalValueMonthly));
                }
            } 
            if (loanCalcRadioButtonAfford.hasClass('active')) {
                var valueAffordText = $('#value-afford-text');
                var monthlyFloatAfford = getMaxLoanForMonthlyBudget(loanCalculatorAffordSliderVal, loanTermVal, loanAprVal);
                var finalValueAfford = monthlyFloatAfford.toFixed(2);
                // Set the values on the front end
                if (isNaN(finalValueAfford)) {
                    valueAffordText.text('N/A');
                } else {
                    // Go and set the window la value
                    var valueToSetAfford = Math.floor(Math.min(5000, parseInt(finalValueAfford)) / 100) * 100;
                    window.la.val(valueToSetAfford).change();
                    // Final text 
                    valueAffordText.text('£'+withCommas(finalValueAfford));
                }
            }
            setLoanCalcTerms();
        }
    }
    
    function setLoanCalcTerms() {
        var loanTermSelectVal = loanTermSelect.val();
        if (loanCalcRadioButtonMonthly.hasClass('active')) {
            var loanCalcValue = parseFloat($('#loan_calculator_val_monthly').text().replace(/[^0-9\.]/g, ''));
        } else if (loanCalcRadioButtonAfford.hasClass('active')) {
            var loanCalcValue = parseFloat($('#value-afford-text').text().replace(/[^0-9\.]/g, ''));
        }
        if (loanTermSelectVal == 3 && loanCalcValue > 1000) {
            loanCalcTermLength = 6;
        } else if (loanTermSelectVal == 6 && loanCalcValue > 2000) {
            loanCalcTermLength = 12;
        } else if (loanTermSelectVal == 18 || loanTermSelectVal == 24 || loanTermSelectVal == 36 && loanCalcValue < 1000) {
            loanCalcTermLength = 12;
        } else {
            loanCalcTermLength = loanTermSelect.val();
        }
        updateCookie(cookieName, 'trm', loanCalcTermLength, expirySeconds);
    }
    
    function showLoanCalcSpinner() {
        if (stopLoanCalcSpinner == true) {
            stopLoanCalcSpinner = false;
            return false;
        } else {
            var loanSummarySection = $('#loan-calculator-summary-section'); 
            var repaymentSpinner = $('#repayment-spinner');
            summaryTextBtnContainer.addClass('hidden');
            summaryTextBtnContainer.removeClass('in');
            repaymentSpinner.removeClass('hidden');
            calculateMyRepaymentsBtnContainer.addClass('hidden');
            loanSummarySection.removeClass('hidden');
            setTimeout(function() {
                if (loanCalculatorMonthlySlider.hasClass('hidden')) { 
                    showSummaryTextAffordContainer();
                } else if (loanCalculatorAffordSlider.hasClass('hidden')) {
                    showSummaryTextMonthlyContainer();
                }
                repaymentSpinner.addClass('hidden');
                summaryTextBtnContainer.removeClass('hidden');
                calculateRepayments();
                setTimeout(function() {
                    summaryTextBtnContainer.removeClass('hidden');
                    summaryTextBtnContainer.addClass('in');
                }, 200);
            }, 1000);
        }
    }
    
    function showSummaryTextMonthlyContainer() {
        summaryTextAffordContainer.addClass('hidden');
        summaryTextMonthlyContainer.removeClass('hidden');
    }
    
    function showSummaryTextAffordContainer() {
        summaryTextMonthlyContainer.addClass('hidden');
        summaryTextAffordContainer.removeClass('hidden');
    }
    
    function markTermFieldValid() {
        termFieldGroup.addClass('valid').removeClass('error');
        termFieldGroupLabel.text('Over how long?');
    }
    
    function markAprFieldValid() {
        aprFieldGroup.addClass('valid').removeClass('error');
        aprFieldGroupLabel.text('APR interest rate');
    }
    
    function errorAprField() {
        aprFieldGroup.addClass('error').removeClass('valid');
        aprFieldGroupLabel.text('Please select an APR interest rate');
    }
    
    function errorTermField() {
        termFieldGroup.addClass('error').removeClass('valid');
        termFieldGroupLabel.text('Please select a term length');
    }
    
    function resetAprField() {
        aprFieldGroup.removeClass('error valid');
        aprFieldGroupLabel.text('APR interest rate');
    }
    
    function showLoanAprInput() {
        loanAprSelect.addClass('hidden');
        loanAprInput.removeClass('hidden');
        calculateRepayments();
        resetAprField();
        loanAprInput.focus();
    }
}

$(document).ready(function(){
    $("a[href='#quote-box']").click(function(event) {
        event.preventDefault(); // Prevent the default action
        $('html, body').animate({
            scrollTop: $("#quote-box").offset().top - 100
        }, 1000); // 1000 milliseconds for the animation
    });
});